import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1016',
    ecrans: ['00-2']
});

